import { render } from "./ProjectAdminRolePage.vue?vue&type=template&id=0fbc452a"
import script from "./ProjectAdminRolePage.vue?vue&type=script&lang=js"
export * from "./ProjectAdminRolePage.vue?vue&type=script&lang=js"
script.render = render

export default script